module.exports = ".button-set:last-child {\n  margin-right: 0 !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/buttons-handler/buttons-handler.component.scss
// module id = ./web/modern/components/common/buttons-handler/buttons-handler.component.scss
// module chunks = 0